import { Button, Grid, TextareaAutosize, Typography } from "@mui/material";
import GenericModal from "../GenericModal";
import { Vocabulary } from "../../Utils/Vocabulary";
import SaveIcon from "@mui/icons-material/Save";
import genericStyles from "../../Styles/genericStyles.module.css";

interface LegalInfoSettingsProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  data: { legalInfo: string; } | null;
  setData: (data: { legalInfo: string; }) => void;
}

const legalInfoOptions = (onClose: any, handleSubmit: any) => {
  return (<div className={genericStyles.modalActions}>
    <Button color="error" variant="outlined" fullWidth onClick={onClose}>
      {Vocabulary.cancel}
    </Button>
    <Button
      fullWidth
      onClick={handleSubmit}
      variant="contained"
      startIcon={<SaveIcon />}
    >
      {Vocabulary.save}
    </Button>
  </div>);
};

export default function LegalInfoSettings(props: LegalInfoSettingsProps) {
  return (
    <GenericModal
      open={props.isOpen}
      onClose={props.onClose}
      title={Vocabulary.legalInformation}
      actions={legalInfoOptions(props.onClose, props.onSubmit)}
    >
      <Grid container spacing={2} >
        <Grid item xs={12}>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            {Vocabulary.legalInfoDescription}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextareaAutosize
            aria-label="legal information"
            placeholder={Vocabulary.addLegalInfo}
            value={props.data?.legalInfo || ""}
            style={{
              width: '100%',
              minHeight: 300,
              fontFamily: 'inherit',
              padding: '8px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              resize: 'vertical'
            }}
            onChange={(e) => props.setData({ legalInfo: e.target.value })}
          />
        </Grid>
      </Grid>
    </GenericModal>
  );
}
